module.exports = __webpack_public_path__ + "static/img/message-template-3.1769678785359.png";